import { render, staticRenderFns } from "./ActionPlanDocumentSlot.vue?vue&type=template&id=5c06c2f8&scoped=true"
import script from "./ActionPlanDocumentSlot.vue?vue&type=script&lang=js"
export * from "./ActionPlanDocumentSlot.vue?vue&type=script&lang=js"
import style0 from "./ActionPlanDocumentSlot.vue?vue&type=style&index=0&id=5c06c2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06c2f8",
  null
  
)

export default component.exports